export default "__VITE_ASSET__BA7XvaHf__"